import React, { useCallback } from "react";
import BaseInput from "./BaseInput/BaseInput";
import CountryPicker from "./CountryPicker";
import { PHONE_COUNTRY_OPTIONS } from "../../utils/countryOptions";

export default function PhoneInput({
  country = "AR",
  onCountryChange,

  value = "",
  onChange,

  ...props
}) {
  const handlePhoneChange = useCallback(
    (nextValue) => {
      const digitsOnly = String(nextValue ?? "").replace(/[^\d]/g, "");
      onChange?.(digitsOnly);
    },
    [onChange],
  );

  return (
    <BaseInput
      {...props}
      type="tel"
      inputMode="numeric"
      pattern="[0-9]*"
      autoComplete="tel"
      value={String(value ?? "")}
      onChange={handlePhoneChange}
      leftIcon={
        <CountryPicker
          options={PHONE_COUNTRY_OPTIONS}
          value={country}
          onChange={(option) => onCountryChange?.(option?.code ?? "")}
          variant="compact"
          display="dial"
          disabled={props.disabled}
          ariaLabel="Prefijo telefónico"
        />
      }
    />
  );
}
